import { render, staticRenderFns } from "./config_zone_1.vue?vue&type=template&id=77e765ae&scoped=true"
import script from "./config_zone_1.vue?vue&type=script&lang=js"
export * from "./config_zone_1.vue?vue&type=script&lang=js"
import style0 from "./config_zone_1.vue?vue&type=style&index=0&id=77e765ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e765ae",
  null
  
)

export default component.exports